const prev_button = document.querySelector("#prev_button");
const next_button = document.querySelector("#next_button");
const body_element = document.querySelector(".viewport");
let viewport_width = body_element.getBoundingClientRect().width;
let visual_card_width = viewport_width,
  margin = 20,
  card_width = visual_card_width + margin,
  breakpoint = 1025;
let position = 0;

// set flexbox to correct width
var flexbox = document.querySelector(".flexbox");

let scroll_width = flexbox.childElementCount * viewport_width;

var new_width = scroll_width;

flexbox.style.width = new_width + "px";

// buttons

const scroll_to_position = function (position) {
  body_element.scroll(position, 0);
};

const recalculate_body_element_width = function () {
  viewport_width = body_element.getBoundingClientRect().width;
  let visual_card_width = viewport_width;
  let margin = 20;
  card_width = visual_card_width + margin;
  breakpoint = 1025;

  let scroll_width = flexbox.childElementCount * viewport_width;

  var new_width = scroll_width;

  flexbox.style.width = new_width + "px";
};

const scroll_to_previous_card = function () {
  let position = body_element.scrollLeft;
  scroll_to_position(position - card_width);
};

const scroll_to_next_card = function () {
  let position = body_element.scrollLeft;
  scroll_to_position(position + card_width);
};

const show_or_hide_buttons = function () {
  let position = body_element.scrollLeft;
  if (position === 0) {
    prev_button.classList.remove("shown");
    prev_button.classList.add("hidden");
    next_button.classList.remove("hidden");
    next_button.classList.add("shown");
  } else if (position === scroll_width - viewport_width) {
    prev_button.classList.remove("hidden");
    prev_button.classList.add("shown");
    next_button.classList.remove("shown");
    next_button.classList.add("hidden");
  } else {
    prev_button.classList.remove("hidden");
    prev_button.classList.add("shown");
    next_button.classList.remove("hidden");
    next_button.classList.add("shown");
  }
};

window.addEventListener("resize", recalculate_body_element_width);
prev_button.addEventListener("click", scroll_to_previous_card);
next_button.addEventListener("click", scroll_to_next_card);
body_element.addEventListener("scroll", show_or_hide_buttons);
